import { withHandlers } from 'recompose'
import ScheduleBlock from './ScheduleBlock'

export default withHandlers({
  handleTimeSelect: ({ onSelect, displayName, value, date }) => () => {
    if (!date) {
      onSelect({ displayName, value })
    } else {
      onSelect({ date, time: { displayName, value }})
    }
  }
})(ScheduleBlock)
